import React, { useState } from 'react';
import { PowerIcon, ClockIcon, MapPinIcon, MoreVerticalIcon, TrashIcon, EditIcon } from 'lucide-react';
export function SceneCard({
  scene,
  onToggle,
  onDelete
}) {
  const [showMenu, setShowMenu] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow" data-id="element-296">
      <div className="flex justify-between items-start mb-4" data-id="element-297">
        <div className="flex-1" data-id="element-298">
          <div className="flex items-center gap-2 mb-1" data-id="element-299">
            <h3 className="text-lg font-semibold" data-id="element-300">{scene.name}</h3>
            <span className={`px-2 py-0.5 rounded text-xs font-medium ${scene.active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`} data-id="element-301">
              {scene.active ? 'Active' : 'Inactive'}
            </span>
          </div>
          <p className="text-sm text-gray-500" data-id="element-302">{scene.description}</p>
        </div>
        <div className="relative" data-id="element-303">
          <button onClick={() => setShowMenu(!showMenu)} className="p-1 hover:bg-gray-100 rounded" data-id="element-304">
            <MoreVerticalIcon size={18} className="text-gray-400" data-id="element-305" />
          </button>
          {showMenu && <div className="absolute right-0 mt-1 w-32 bg-white rounded-lg shadow-lg border border-gray-200 z-10" data-id="element-306">
              <button className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center" data-id="element-307">
                <EditIcon size={14} className="mr-2" data-id="element-308" />
                Edit
              </button>
              <button onClick={() => {
            onDelete(scene.id);
            setShowMenu(false);
          }} className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-gray-50 flex items-center" data-id="element-309">
                <TrashIcon size={14} className="mr-2" data-id="element-310" />
                Delete
              </button>
            </div>}
        </div>
      </div>
      <div className="space-y-3 mb-4" data-id="element-311">
        <div className="flex items-start" data-id="element-312">
          <ClockIcon size={16} className="text-gray-400 mr-2 mt-0.5" data-id="element-313" />
          <div data-id="element-314">
            <p className="text-sm font-medium text-gray-700" data-id="element-315">Trigger</p>
            <p className="text-sm text-gray-500" data-id="element-316">{scene.trigger}</p>
          </div>
        </div>
        <div data-id="element-317">
          <p className="text-sm font-medium text-gray-700 mb-2" data-id="element-318">
            Devices ({scene.devices.length})
          </p>
          <div className="flex flex-wrap gap-1" data-id="element-319">
            {scene.devices.map((device, index) => <span key={index} className="px-2 py-1 bg-green-50 text-green-700 text-xs rounded" data-id="element-320">
                {device}
              </span>)}
          </div>
        </div>
        <div data-id="element-321">
          <p className="text-sm font-medium text-gray-700 mb-2" data-id="element-322">Actions</p>
          <ul className="space-y-1" data-id="element-323">
            {scene.actions.slice(0, 2).map((action, index) => <li key={index} className="text-sm text-gray-600" data-id="element-324">
                • {action.device}: {action.action}
              </li>)}
            {scene.actions.length > 2 && <li className="text-sm text-gray-400" data-id="element-325">
                +{scene.actions.length - 2} more actions
              </li>}
          </ul>
        </div>
      </div>
      <div className="flex items-center justify-between pt-4 border-t border-gray-100" data-id="element-326">
        <p className="text-xs text-gray-400" data-id="element-327">
          Last activated: {new Date(scene.lastActivated).toLocaleString()}
        </p>
        <button onClick={() => onToggle(scene.id)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${scene.active ? 'bg-gray-100 text-gray-700 hover:bg-gray-200' : 'bg-green-600 text-white hover:bg-green-700'}`} data-id="element-328">
          {scene.active ? 'Deactivate' : 'Activate'}
        </button>
      </div>
    </div>;
}